import Image from 'app/Components/Shared/Image/image';
﻿import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import Footer from '../Partials/SaleFooter/SaleFooter';
import { reportDWH } from '../energySaleBlockSlice';
import { openWhatsAppLink} from '../energySaleBlockAsyncThunk';
import ErrorIcon from '../images/error-icon.svg'
import { gtag4 } from '../../../../utilities/analytics/tracking';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';

const ErrorPage = (props) => {

  useExtendedEffect((runSideEffects) => {
    gtag4({
      event: 'Energy_ErrorMessage',
      action: 'ErrorMessage',
      error: props.errorDescription,
    });
    props.reportDWH({ actionType: 'Error', status: 'Error', messageText: props.errorDescription })
    if (runSideEffects()) {
    }
  },
  [],);

  //page params
  let title = '';
  let subTitle = '';
  let iconType = ErrorIcon;
  let btnText = '';
  let btnFunction = null;
  let currentPageFunction = handlePageContinue;
  const formid = 'energySaleBlock';
  let isDisplayFooter = false;
  //page params

  switch (props.errorType) {
    case "GENERAL_ERROR":
      title = "מצטערים משהו השתבש \n והתהליך לא הושלם";
      subTitle = "נשמח ליצור איתך קשר כדי לעזור";
      if(props.isWhatsAppActive){
        isDisplayFooter = true;
        btnFunction = openWhatsApp;
        btnText = 'לנציג אנושי ב-WhatsApp';
      }
      break;
    case "ALREADY_EXIST":
      title = "שמנו לב שמספר המונה שלך \n כבר קיים במערכת";
      subTitle = "נשמח ליצור איתך קשר כדי לעזור";
      if(props.isWhatsAppActive){
        isDisplayFooter = true;
        btnFunction = openWhatsApp;
        btnText = 'לנציג אנושי ב-WhatsApp';
      }
      break;
    case "EMPTY_DETAILS":
        title = "נראה שהפרטים שהזנת אינם תואמים \n לפרטים שקיימים בחברת חשמל";
        subTitle = "נשמח ליצור איתך קשר כדי לעזור";
        if(props.isWhatsAppActive){
          isDisplayFooter = true;
          btnFunction = openWhatsApp;
          btnText = 'לנציג אנושי ב-WhatsApp';
        }
      break;
    case "HAS_MULTIPLE_COUNTERS":
        title = "לא מצאנו מידע על חשבון החשמל שלך";
        subTitle = `אבל אפשר להתקדם עם נציג ${window.Config.brand_Name_HE} \n ולחסוך עד 20% מחשבון החשמל שלך`;
        if(props.isWhatsAppActive){
          isDisplayFooter = true;
          btnFunction = openWhatsApp;
          btnText = 'לנציג אנושי ב-WhatsApp';
        }
     break;
  }

  let currentPageHeadline = (
    <div className='page-headline-wrapper'>
      <Image className='energy-sale-icon' src={iconType} alt='' />
      <h1 className='energy-sale-title'> {title} </h1>
      <h2 className='energy-sale-sub-title'> {subTitle} </h2>
    </div>
  );

  return (
    <>
      <div className='energy-sale-content-wrapper'>
        {currentPageHeadline}
        <div className='energy-sale-page-content'>
        </div>
      </div>
      <Footer isDisplayFooter={isDisplayFooter} isDisplayWhatsAppIcon={props.isWhatsAppActive} btnText={btnText} onclick={currentPageFunction} formid={formid} />
    </>
  );

  function handlePageContinue() {
    btnFunction();
  }


  function openWhatsApp(){
    gtag4({
      event: 'Energy_ErrorWaButton',
      action: 'ErrorWaButton',
      error: props.errorDescription,
    });
    props.openWhatsAppLink()
  }


};

const mapStateToProps = (state) => {
  return {
    errorType: state.energySaleBlock.errorPage.errorType,
    errorDescription: state.energySaleBlock.errorPage.description,
    isWhatsAppActive : state.energySaleBlock.energySaleBlockData.isWhatsAppActive,
  };
};

const mapDispatchToProps = {
  openWhatsAppLink,
  reportDWH
};

export default connect(mapStateToProps, mapDispatchToProps)(ErrorPage);
